import { useEffect, useState } from 'react';
import { selectLastCheckedDocument, useAppSelector } from '@ibk/shared-config';
import { AppDomain } from '@ibk/shared-types';
import { getCookie, setCookie } from '@ibk/shared-utils';
const SURVEY_CLICK_KEY = 'productServiceSurveyAlertSurveyClicks';
const CLOSE_CLICK_KEY = 'productServiceSurveyAlertCloseClicks';
const DEADLINE = new Date('2025-10-31T23:59:59');
const MAX_SURVEY_CLICKS = 2;
const MAX_CLOSE_CLICKS = 2;
const SURVEY_URL_EMPRESA = 'https://forms.office.com/pages/responsepage.aspx?id=ZLjMYhpqXUuOHDl97BqCWCG7WYivwSlDoac9WfP4DI9UMkg2T05aRFdRTjhFUzcwNTJCWDdOTTExMyQlQCN0PWcu&route=shorturl';
const SURVEY_URL_ESCRITORIO = 'https://forms.office.com/pages/responsepage.aspx?id=ZLjMYhpqXUuOHDl97BqCWCG7WYivwSlDoac9WfP4DI9UMDhIVEE5N0cxMExDTkJWMzJQOVRDT0JYSyQlQCN0PWcu&route=shorturl';
const SURVEY_URLS = {
    [AppDomain.EMPRESA]: SURVEY_URL_EMPRESA,
    [AppDomain.ESCRITORIO]: SURVEY_URL_ESCRITORIO,
};
export function useProductServiceSurveyAlert(appDomain) {
    const [isVisible, setIsVisible] = useState(false);
    const userCpf = useAppSelector(selectLastCheckedDocument) ?? '';
    const [surveyClickCookieKey, setSurveyClickCookieKey] = useState('');
    const [closeClickCookieKey, setCloseClickCookieKey] = useState('');
    useEffect(() => {
        if (userCpf) {
            setSurveyClickCookieKey(`${SURVEY_CLICK_KEY}_${userCpf}`);
            setCloseClickCookieKey(`${CLOSE_CLICK_KEY}_${userCpf}`);
        }
    }, [userCpf]);
    useEffect(() => {
        if (surveyClickCookieKey && closeClickCookieKey) {
            const now = new Date();
            const surveyClicks = Number(getCookie(surveyClickCookieKey) ?? 0);
            const closeClicks = Number(getCookie(closeClickCookieKey) ?? 0);
            if (now <= DEADLINE && surveyClicks < MAX_SURVEY_CLICKS && closeClicks < MAX_CLOSE_CLICKS) {
                setIsVisible(true);
            }
        }
    }, [surveyClickCookieKey, closeClickCookieKey]);
    const handleClose = () => {
        const closeClicks = Number(getCookie(closeClickCookieKey) ?? 0) + 1;
        setCookie(closeClickCookieKey, closeClicks.toString());
        setIsVisible(false);
    };
    const handleLinkClick = () => {
        const surveyClicks = Number(getCookie(surveyClickCookieKey) ?? 0) + 1;
        setCookie(surveyClickCookieKey, surveyClicks.toString());
        const url = SURVEY_URLS[appDomain];
        if (url) {
            window.open(url, '_blank');
        }
        setIsVisible(false);
    };
    return {
        isVisible,
        handleClose,
        handleLinkClick,
    };
}
